import {Locales} from '@netx/core-next/locales/utils/Locales';
import {ContentsType} from './constants';

export const ContentsTypeLabel: Record<ContentsType, string> = Locales(
	(i18n) => ({
		[ContentsType.MATCH_ALL_FRAGMENTS]: i18n('i18n.matchAllFragments'),
		[ContentsType.MATCH_ALL_WHOLE_WORDS_AND]: i18n(
			'i18n.matchAllWholeWordsAND',
		),
		[ContentsType.MATCH_ANY_FRAGMENT]: i18n('i18n.matchAnyFragment'),
		[ContentsType.MATCH_ANY_WHOLE_WORDS_OR]: i18n('i18n.matchAnyWholeWordsOR'),
		[ContentsType.MATCH_EXACTLY]: i18n('i18n.matchExactly'),
		[ContentsType.MATCH_EXCLUDE]: i18n('i18n.matchExclude'),
	}),
);
